import { render, staticRenderFns } from "./HrSalaryInsSocial.vue?vue&type=template&id=5e4870ac&scoped=true&"
import script from "./HrSalaryInsSocial.vue?vue&type=script&lang=js&"
export * from "./HrSalaryInsSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4870ac",
  null
  
)

export default component.exports